import { t } from "@/i18n-js/instance";

import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../../FirstPaymentPreview/types";

export const TaxLine = ({ preview, options }: ComponentLineProps) => (
  <DefaultFullPreview.PreviewEntry
    label={t("paywall_checkout.coupon.tax")}
    value={preview?.future_payments?.formatted_tax}
    dataTestId="checkout-form-preview-future-payments-tax"
    {...options}
  />
);
